export const getPortfolioImageAlt = (image) => {
  if (!image) {
    return 'Portfolio photo by Cassidy Sullivan Photography';
  }

  const categoryLabels = {
    equine: 'equine photography',
    'black-background': 'black background equine photography',
    couples: 'couples photography',
    weddings: 'wedding photography',
    family: 'family photography',
    senior: 'senior photography',
    prom: 'prom photography',
    pets: 'pet photography'
  };

  const category = categoryLabels[image.category] || 'photography';
  const title = typeof image.title === 'string' ? image.title.trim() : '';
  const description = typeof image.description === 'string' ? image.description.trim() : '';

  const subject = title || 'Portfolio image';
  const detail = description ? `, ${description}` : '';

  return `${subject}${detail} — ${category} by Cassidy Sullivan Photography in Kentucky`;
};
